import { c as _c } from "react/compiler-runtime";
import { Checkbox } from 'platform/components';
import { MouseEvent } from 'react';
import { SELECTION_COLUMN_WIDTH, SELECTION_TEST_ID_PREFIX } from '../../../../../../constants/selectionColumn';
interface RowSelectCheckboxProps {
  isSelected: boolean;
  /** Row ID forwarded to onToggleSelection — avoids creating an inline arrow at the call site. */
  rowId: string;
  onToggleSelection: (rowId: string) => void;
  rowIndex?: number;
}
export function RowSelectCheckbox(props) {
  const $ = _c(7);
  const handleClick = _temp;
  let t0;
  if ($[0] !== props) {
    t0 = () => {
      props.onToggleSelection(props.rowId);
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleChange = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: SELECTION_COLUMN_WIDTH,
      position: "sticky",
      left: 0,
      zIndex: "var(--z-content)"
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `${SELECTION_TEST_ID_PREFIX}-row-${props.rowIndex ?? 0}`;
  let t3;
  if ($[3] !== handleChange || $[4] !== props.isSelected || $[5] !== t2) {
    t3 = <td className="p-0 text-center select-none bg-white" style={t1} onClick={handleClick}><div className="flex items-center justify-center h-full"><Checkbox value={props.isSelected} onChange={handleChange} data-testid={t2} /></div></td>;
    $[3] = handleChange;
    $[4] = props.isSelected;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(event) {
  event.stopPropagation();
}